export const getTranslateKey = (isOnlineEvent) => {
  const labels = new Map();
  const NO_ONLINE_EVENT = 'noOnlineEvent';
  const ONLINE_EVENT = 'onlineEvent';

  labels.set(NO_ONLINE_EVENT, {
    title: 'onboarding.done.ready_to_go_new',
    subtitle: 'onboarding.done.finish_product_registration_new',
    cta: 'onboarding.done.back_to_registration_new',
    tip: 'onboarding.done.continue_adding_content'
  });
  labels.set(ONLINE_EVENT, {
    title: 'onboarding.online_event.steps.done.new_area_published_new',
    subtitle: 'onboarding.online_event.steps.done.area_description_new',
    cta: 'onboarding.online_event.steps.done.continue_registration',
    tip: 'onboarding.online_event.steps.done.new_add_more_content'
  });

  return labels.get(isOnlineEvent ? ONLINE_EVENT : NO_ONLINE_EVENT);
};
